import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const YouAreInGoodHands = lazyWithPreload(
  () => import('./YouAreInGoodHands'),
)
export const YouAreInGoodHandsVariant2 = lazyWithPreload(
  () => import('./YouAreInGoodHandsVariant2'),
)
